export default "__VITE_ASSET__DfE$mlJA__"